import React from 'react';
import PropTypes from 'prop-types';
import { Card, Spinner } from 'react-bootstrap';
import { FiEye } from 'react-icons/fi';
import { css } from 'twin.macro';
import EmailDraftDeleteButton from './EmailDraftDeleteButton';
import { ActionStyles } from '@/components/Admin/reusableStyles';

const rowStyle = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid #e7e9ee;
    border-radius: 12px;
    background: #fff;
    cursor: pointer;
    transition:
        transform 120ms ease,
        box-shadow 120ms ease,
        border-color 120ms ease;

    &:hover {
        transform: translateY(-1px);
        border-color: #cfd7e3;
        box-shadow: 0 8px 24px rgba(18, 26, 40, 0.06);
    }

    &:focus-visible {
        outline: 2px solid #7aa7ff;
        outline-offset: 2px;
    }
`;

const metaStyle = css`
    display: flex;
    flex-direction: column;
    min-width: 0;
`;

const titleStyle = css`
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const subtitleStyle = css`
    font-size: 12px;
    color: #6b7280;
`;

const EmailDraftsList = ({ drafts = [], loading = false, onOpenDraft = () => {}, onDeleteDraft = () => {} }) => {
    if (loading && !drafts.length) {
        return (
            <div className="d-flex justify-content-center py-4">
                <Spinner animation="border" />
            </div>
        );
    }

    if (!drafts.length) {
        return <Card className="border-0 shadow-sm p-3 text-muted">No drafts found.</Card>;
    }

    return (
        <div className="d-grid gap-2">
            {drafts.map((draft) => (
                <div
                    key={draft.id || draft._id}
                    css={rowStyle}
                    role="button"
                    tabIndex={0}
                    onClick={() => onOpenDraft(draft)}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            onOpenDraft(draft);
                        }
                    }}
                    aria-label={`Open draft ${draft.subject || 'with no subject'}`}
                    title="Open draft"
                >
                    <div css={metaStyle}>
                        <div css={titleStyle}>
                            {draft.subject
                                ? draft.subject.length > 100
                                    ? draft.subject.slice(0, 100) + '...'
                                    : draft.subject
                                : '(no subject)'}
                        </div>
                        <div css={subtitleStyle}>{new Date(draft.updatedAt || draft.createdAt).toLocaleString()}</div>
                    </div>
                    <div>
                        <ActionStyles>
                            <FiEye
                                className="icon view"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onOpenDraft(draft);
                                }}
                                aria-label="Open draft"
                                title="View draft"
                            />
                            <EmailDraftDeleteButton draft={draft} onDelete={onDeleteDraft} className="ml-2" />
                        </ActionStyles>
                    </div>
                </div>
            ))}
        </div>
    );
};

EmailDraftsList.propTypes = {
    drafts: PropTypes.array,
    loading: PropTypes.bool,
    onOpenDraft: PropTypes.func,
    onDeleteDraft: PropTypes.func,
};

export default EmailDraftsList;
